(function () {
    'use strict';

    angular
        .module('core.directives')
        .directive('unitWorkingTime', UnitWorkingTime);

    /** @ngInject */
    function UnitWorkingTime($q, $rootScope, UnitService, HelperService, PATHS) {
        function UnitWorkingTimeDirectiveController($scope) {
            const vm = this;

            let removeWatchShow = $scope.$watch('vm.show', (newValue, oldValue) => {
                if (newValue)
                    init();
            });

            $scope.$on('$destroy', () => {
                removeWatchShow();
            });

            vm.saveWorkingTime = () => {
                HelperService.startLoading('.loading-holder');

                vm.workingTimes.forEach(time => {
                    if (time.Closed || (!time.Closed && (time.StartHourId == null || time.EndHourId == null))) {
                        time.StartHourId = null;
                        time.EndHourId = null;
                        time.Closed = true;
                    }
                })

                if (vm.workingTimes[0].Id) {
                    UnitService
                        .putWorkingTime(vm.workingTimes)
                        .then(success => {
                            vm.workingTimes = success;

                            HelperService.stopLoading('.loading-holder');
                            HelperService.successCallback('update');
                        }, error => {
                            HelperService.stopLoading('.loading-holder');
                            HelperService.errorCallback(error);
                        })
                } else {
                    UnitService
                        .postWorkingTime(vm.workingTimes)
                        .then(success => {
                            vm.workingTimes = success;

                            HelperService.stopLoading('.loading-holder');
                            HelperService.successCallback();
                        }, error => {
                            HelperService.stopLoading('.loading-holder');
                            HelperService.errorCallback(error);
                        })
                }
            }

            function prepareWorkingTimeWeek() {
                const unitId = vm.unitData.Id;

                for (let index = 0; index < vm.weekDays.length; index++) {
                    let weekDay = vm.weekDays[index];
                    let workingTime = vm.workingTimes.find(wt => wt.WeekDayId == weekDay.Id);

                    if (!workingTime) {
                        let newWorkingTime = {
                            StartHourId: null,
                            EndHourId: null,
                            WeekDayId: weekDay.Id,
                            WeekDay: weekDay,
                            UnitId: unitId,
                            Closed: false
                        };

                        vm.workingTimes.push(newWorkingTime);
                    }
                }
            }

            function getHours() {
                return UnitService
                    .getHours()
                    .then(
                        success => {
                            let hours = success.filter(x => x.Active);

                            hours.forEach(hour => {
                                hour.momentHour = moment()
                                    .hours(hour.Horary.substring(0, 2))
                                    .minutes(hour.Horary.substring(3, 5))
                            });

                            vm.hours = hours;

                            HelperService.stopLoading('.loading-holder');
                        }, error => {
                            HelperService.stopLoading('.loading-holder');
                            HelperService.errorCallback(error);
                        });
            }

            function initVars() {
                vm.canUserCreate = $rootScope.canUserCreate;
                vm.canUserEdit = $rootScope.canUserEdit;

                vm.weekDays = [{
                    Id: 2,
                    Day: 'Segunda-feira',
                    Class: 'purple'
                }, {
                    Id: 3,
                    Day: 'Terça-feira',
                    Class: 'purple'
                }, {
                    Id: 4,
                    Day: 'Quarta-feira',
                    Class: 'purple'
                }, {
                    Id: 5,
                    Day: 'Quinta-feira',
                    Class: 'purple'
                }, {
                    Id: 6,
                    Day: 'Sexta-feira',
                    Class: 'purple'
                }, {
                    Id: 7,
                    Day: 'Sábado',
                    Class: 'orange'
                }, {
                    Id: 1,
                    Day: 'Domingo',
                    Class: 'orange'
                }]
            }

            function init() {
                HelperService.startLoading('.loading-holder');

                vm.workingTimes = vm.unitData.UnitOperation;

                initVars();

                $q.all([getHours()])
                    .then(() => {
                        prepareWorkingTimeWeek();
                    });
            }
        }

        return {
            bindToController: true,
            controller: UnitWorkingTimeDirectiveController,
            controllerAs: 'vm',
            restrict: 'AE',
            templateUrl: `${PATHS.PHYSICAL}/directives/unit-working-time/unit-working-time.html`,
            scope: {
                unitData: '=',
                show: '='
            }
        }
    }
}());